import React, { useEffect, useState } from 'react'
import em from './em.module.css'
import imgI from '../../../img/new/7.png'
import imgII from '../../../img/new/8.png'
import imgIII from '../../../img/new/6.png'
import imgIV from '../../../img/logo 1.png'
import { FaLinkedin, FaUnlink } from 'react-icons/fa'
import { LuFileSliders } from 'react-icons/lu'
import { MdOutlineDashboard, MdOutlineEmail } from 'react-icons/md'
import { Link } from 'react-router'
import { CiSearch, CiSettings } from 'react-icons/ci'
// import { fetchData } from '../../../Api/PostManApi'
const Employ = () => {

    const [search, setSearch] = useState('')
   
    
         

        // const [posts, setPosts] = useState([]);

        // useEffect(() => {
        //   const getPosts = async () => {
        //     const data = await fetchData();
        //     setPosts(data);
        //   };
        //   getPosts();
        // }, []);




  return (
    <div className={em.em }>
      <div className={em.container}>
      <div className={em.contentI}>
            <img src={imgIV} className={em.img} alt="" />
        </div>
        <div className={em.content}>
            <div className={em.block}>
                <div className={em.blocki}>
                         <div className={em.seci}>
                            <Link to='/Admin/AdminBoard'>
                            <div className={em.icon}>
                                <MdOutlineDashboard/>
                                <h3 >Dashboard</h3>
                            </div>
                            </Link>
                            <Link to='/Admin/AdminBoard/AdminEmploy'>
                            <div className={em.icon}>
                                <LuFileSliders  className={em.word} />
                                <h3 className={em.word}> Employees</h3>
                            </div>
                            </Link  >
                            <Link to='/Admin/AdminBoard/AccessCode'>
                            <div className={em.icon}>
                                <LuFileSliders />
                                <h3>Access Code</h3>
                            </div>
                            </Link>
                        </div>
                        <div className={em.seciI}>
                            <div className={em.icon}>
                                <CiSettings />
                                <h3>Settings</h3>
                            </div>
                            <Link to='/Admin'>
                            <div className={em.icon}>                               
                                <h3>Logout</h3>
                            </div>
                            </Link>
                        </div>
                </div>
                <div className={em.blockI}>
               

         <div className={em.flex}>

                    </div>
                    <div className={em.flex}>
                        <h3>Employees</h3>
                        <div className={em.flexI}>
                            <div className={em.inp}>
                                <input type="search"
                                onChange={(e) => setSearch(e.target.value)}
                                name="" id="" />
                                <CiSearch />
                            </div>
                            <img className={em.imgi} src={imgI} alt="" />
                        </div>
                    </div>
                    <div className={em.flexII}>
                        <div className={em.card}>
                            <div className={em.img1}>
                                <img src={imgII} alt="" />
                                <div className={em.para}>
                                    <h5>Yemi Olakitan</h5>
                                    <p>General Manager</p>
                                </div>
                               
                            </div>
                            <div className={em.flexi}>
                                    <p>Yemi is a versatile worker, generally he control and 
                                        supervises other employees. due to his work ethics, 
                                        he is seen as a good manager who makes sure 
                                        things are done at the right time and quick.</p>
                                    <div className={em.bttn}>
                                        <button><MdOutlineEmail />Olakitan@gmail.com</button>
                                        <button><FaLinkedin />@Olikatn_Yemi</button>
                                    </div>
                                    <div className={em.bttnI}>
                                        <Link to='/Admin/AdminBoard/AdminEmploy/AdminEdit'>
                                        <button className={em.btni}>Edit Profile</button>
                                        </Link>
                                        <button className={em.btnii}>Revoke Access</button>
                                    </div>
                             </div>
                        </div>
                        <div className={em.card}>
                            <div className={em.img1}>
                                <img src={imgII} alt="" />
                                <div className={em.para}>
                                    <h5>Yemi Olakitan</h5>
                                    <p>General Manager</p>
                                </div>
                               
                            </div>
                            <div className={em.flexi}>
                                    <p>Yemi is a versatile worker, generally he control and 
                                        supervises other employees. due to his work ethics, 
                                        he is seen as a good manager who makes sure 
                                        things are done at the right time and quick.</p>
                                    <div className={em.bttn}>
                                        <button><MdOutlineEmail />Olakitan@gmail.com</button>
                                        <button><FaLinkedin />@Olikatn_Yemi</button>
                                    </div>
                                    <div className={em.bttnI}>
                                        <Link to='/Admin/AdminBoard/AdminEmploy/AdminEdit'>
                                        <button className={em.btni}>Edit Profile</button>
                                        </Link>
                                        <button className={em.btnii}>Revoke Access</button>
                                    </div>
                             </div>
                        </div>
                        <div className={em.card}>
                            <div className={em.img1}>
                                <img src={imgII} alt="" />
                                <div className={em.para}>
                                    <h5>Yemi Olakitan</h5>
                                    <p>General Manager</p>
                                </div>
                               
                            </div>
                            <div className={em.flexi}>
                                    <p>Yemi is a versatile worker, generally he control and 
                                        supervises other employees. due to his work ethics, 
                                        he is seen as a good manager who makes sure 
                                        things are done at the right time and quick.</p>
                                    <div className={em.bttn}>
                                        <button><MdOutlineEmail />Olakitan@gmail.com</button>
                                        <button><FaLinkedin />@Olikatn_Yemi</button>
                                    </div>
                                    <div className={em.bttnI}>
                                        <Link to='/Admin/AdminBoard/AdminEmploy/AdminEdit'>
                                        <button className={em.btni}>Edit Profile</button>
                                        </Link>
                                        <button className={em.btnii}>Revoke Access</button>
                                    </div>
                             </div>
                        </div>
                        <div className={em.card}>
                            <div className={em.img1}>
                                <img src={imgII} alt="" />
                                <div className={em.para}>
                                    <h5>Yemi Olakitan</h5>
                                    <p>General Manager</p>
                                </div>
                               
                            </div>
                            <div className={em.flexi}>
                                    <p>Yemi is a versatile worker, generally he control and 
                                        supervises other employees. due to his work ethics, 
                                        he is seen as a good manager who makes sure 
                                        things are done at the right time and quick.</p>
                                    <div className={em.bttn}>
                                        <button><MdOutlineEmail />Olakitan@gmail.com</button>
                                        <button><FaLinkedin />@Olikatn_Yemi</button>
                                    </div>
                                    <div className={em.bttnI}>
                                        <Link to='/Admin/AdminBoard/AdminEmploy/AdminEdit'>
                                        <button className={em.btni}>Edit Profile</button>
                                        </Link>
                                        <button className={em.btnii}>Revoke Access</button>
                                    </div>
                             </div>
                        </div>
                        <div className={em.card}>
                            <div className={em.img1}>
                                <img src={imgI} alt="" />
                                <div className={em.para}>
                                    <h5>Yemi Olakitan</h5>
                                    <p>General Manager</p>
                                </div>
                               
                            </div>
                            <div className={em.flexi}>
                                    <p>Yemi is a versatile worker, generally he control and 
                                        supervises other employees. due to his work ethics, 
                                        he is seen as a good manager who makes sure 
                                        things are done at the right time and quick.</p>
                                    <div className={em.bttn}>
                                        <button><MdOutlineEmail />Olakitan@gmail.com</button>
                                        <button><FaLinkedin />@Olikatn_Yemi</button>
                                    </div>
                                    <div className={em.bttnI}>
                                        <Link to='/Admin/AdminBoard/AdminEmploy/AdminEdit'>
                                        <button className={em.btni}>Edit Profile</button>
                                        </Link>
                                        <button className={em.btnii}>Revoke Access</button>
                                    </div>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Employ
